var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import graph from "@irati/utils/services/graph";
import PBService from "@irati/utils/services";
import { toString as walletQuery } from "./query/wallet";
import { toString as userWalletQuery } from "./query/UserWalletList";
import { toString as tenantWalletQuery } from "./query/TenantWalletList";
import { toString as giftUserWalletCreditMutation } from "./mutation/giftUserWalletCredit";
import { toString as sendCreditToUserMutation } from "./mutation/sendCreditToUser";
import walletErrorHandler from "../helpers/errors/walletErrorHandler";
var WalletService = /** @class */ (function (_super) {
    __extends(WalletService, _super);
    function WalletService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WalletService.prototype.get = function (userId, currency, options) {
        if (options === void 0) { options = {}; }
        return graph({ query: walletQuery, variables: { userId: userId, currency: currency } }, options).then(function (response) { return response.wallet; });
    };
    WalletService.prototype.giftUserWalletCredit = function (userId, amount, currency, reason) {
        return graph({ query: giftUserWalletCreditMutation, variables: { userId: userId, amount: amount, currency: currency, reason: reason } });
    };
    WalletService.prototype.sendCreditToUser = function (senderId, receiverId, amount, currency) {
        return graph({ query: sendCreditToUserMutation, variables: { senderId: senderId, receiverId: receiverId, amount: amount, currency: currency } });
    };
    WalletService.prototype.userWalletList = function (userId) {
        return graph({ query: userWalletQuery, variables: { userId: userId } }).then(function (res) { return res.userWalletList; });
    };
    WalletService.prototype.tenantWalletList = function (tenantId) {
        return graph({ query: tenantWalletQuery, variables: { tenantId: tenantId } }).then(function (res) { return res.tenantWalletList; });
    };
    return WalletService;
}(PBService));
var service = new WalletService({ errorHandlers: [walletErrorHandler] });
export var getWallet = service.get;
export var giftUserWalletCredit = service.giftUserWalletCredit;
export var sendCreditToUser = service.sendCreditToUser;
export var getUserWalletList = service.userWalletList;
export var getTenantWalletList = service.tenantWalletList;
export default service;
